import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import { NotifyHelpers } from '@/ts/helpers/NotifyHelpers';

@Module({name: 'Tickets', namespaced: true})
export default class TicketAttributes extends VuexModule {
    public addCategoryVisible: boolean = false;
    public addInquiryVisible: boolean = false;
    public editCategoryVisible: boolean = false;
    public editInquiryVisible: boolean = false;
    public ticketAllTypes: any = [];
    public inquiryRoles: any = [];
    public inquiryRoleUsers: any = [];
    public currentEditCategory: any = [];
    public currentEditInquiry: any = [];
    public ticketAllCategories: any = [];
    public ticketAllInquiries: any = [];
    public currentTicketType: number = 0;
    public currentTicketCategory: number = 0;
    public currentProject: number = 0;

    @Mutation
    public RESET_TICKET_ATTRIBUTES_STORE_STATE() {
        this.addCategoryVisible    = false;
        this.addInquiryVisible     = false;
        this.editCategoryVisible   = false;
        this.editInquiryVisible    = false;
        this.ticketAllTypes        = [];
        this.inquiryRoles          = [];
        this.inquiryRoleUsers      = [];
        this.currentEditCategory   = [];
        this.currentEditInquiry    = [];
        this.ticketAllCategories   = [];
        this.ticketAllInquiries    = [];
        this.currentTicketType     = 0;
        this.currentTicketCategory = 0;
        this.currentProject        = 0;
    }

    get getCurrentTicketType() {
        return this.currentTicketType;
    }

    get getInquiryRoles() {
        return this.inquiryRoles;
    }

    get getInquiryRoleUsers() {
        return this.inquiryRoleUsers;
    }

    get getCurrentTicketCategory() {
        return this.currentTicketCategory;
    }

    get getAddCategoryVisible() {
        return this.addCategoryVisible;
    }

    get getCurrentProject() {
        return this.currentProject;
    }

    get getTicketAllTypes() {
        return this.ticketAllTypes;
    }

    get getCurrentEditCategory() {
        return this.currentEditCategory;
    }

    get getCurrentEditInquiry() {
        return this.currentEditInquiry;
    }

    get getEditInquiryVisible() {
        return this.editInquiryVisible;
    }

    get getEditCategoryVisible() {
        return this.editCategoryVisible;
    }

    get getTicketAllInquiries() {
        return this.ticketAllInquiries;
    }

    get getTicketAllCategories() {
        return this.ticketAllCategories;
    }

    get getAddInquiryVisible() {
        return this.addInquiryVisible;
    }

    @Action
    public FETCH_TICKET_ALL_TYPES() {
        axios.get(Endpoints.Admin.TicketsAttributes.TICKET_ALL_TYPES)
            .then((response: any) => {
                store.commit(Mutations.SET_TICKET_ALL_TYPES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_TICKET_ALL_CATEGORIES(data: any) {
        axios.get(Endpoints.Admin.TicketsAttributes.TICKET_ALL_CATEGORIES(data.projectId, data.typeId, data.trash))
            .then((response: any) => {
                store.commit(Mutations.SET_TICKET_ALL_CATEGORIES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_TICKET_INQUIRIES(data: any) {
        axios.get(Endpoints.Admin.TicketsAttributes.TICKET_INQUIRIES(data.typeId, data.categoryId, data.projectId))
            .then((response: any) => {
                store.commit(Mutations.SET_TICKET_ALL_INQUIRIES, response.data.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_CURRENT_EDIT_CATEGORY(categoryId: number) {
        axios.get(Endpoints.Admin.TicketsAttributes.SINGLE_CATEGORY(categoryId))
            .then((response: any) => {
                store.commit(Mutations.SET_CURRENT_EDIT_CATEGORY, response.data.data);
                store.commit(Mutations.SET_EDIT_CATEGORY_VISIBILITY, true);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public DELETE_INQUIRY_CATEGORY(data: any) {
        axios.delete(Endpoints.Admin.TicketsAttributes.SINGLE_INQUIRY_CATEGORY(data.projectId, data.typeId, data.categoryId))
            .then((response: any) => {
                if (response.data) {
                    store.commit(Mutations.SET_CURRENT_EDIT_CATEGORY, []);
                    store.dispatch(Actions.FETCH_TICKET_ALL_CATEGORIES, { projectId: data.projectId, typeId: data.typeId, trash: false });
                    store.commit(Mutations.SET_CURRENT_TICKET_CATEGORY, 0);
                    store.commit(Mutations.SET_EDIT_CATEGORY_VISIBILITY, false);

                    NotifyHelpers.notify('category_has_been_deleted', 'positive');
                } else {

                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 400) {
                        NotifyHelpers.notify('category_cannot_be_deleted_as_it_has_assigned_inquiries', 'warning');
                    } else {
                        const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                        store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    }
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public DELETE_INQUIRY(data: any) {
        axios.delete(Endpoints.Admin.TicketsAttributes.SINGLE_INQUIRY(data.projectId, data.inquiryId))
            .then((response: any) => {
                if (response.data) {
                    store.commit(Mutations.SET_CURRENT_EDIT_INQUIRY, []);
                    store.dispatch(Actions.FETCH_TICKET_INQUIRIES, { typeId: data.typeId, categoryId: data.categoryId, projectId: data.projectId});
                    store.commit(Mutations.SET_EDIT_INQUIRY_VISIBILITY, false);

                    NotifyHelpers.notify('inquiry_has_been_deleted', 'positive');
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 400) {
                        NotifyHelpers.notify('inquiry_cannot_be_deleted_as_it_has_assigned_tickets', 'warning');
                    } else {
                        const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                        store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    }
                } else {
                    console.log(error);
                }
            });
        }

    @Action
    public FETCH_CURRENT_EDIT_INQUIRY(data: any) {
        axios.get(Endpoints.Admin.TicketsAttributes.SINGLE_INQUIRY(data.projectId, data.inquiryId))
            .then((response: any) => {
                store.commit(Mutations.SET_CURRENT_EDIT_INQUIRY, response.data.data);
                store.commit(Mutations.SET_EDIT_INQUIRY_VISIBILITY, true);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_INQUIRY_ROLE_ASSIGNEE() {
        axios.get(Endpoints.Admin.TicketsAttributes.INQUIRY_ROLE_ASSIGNEE)
            .then((response: any) => {
                store.commit(Mutations.SET_INQUIRY_ROLE_ASSIGNEE, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_INQUIRY_ROLE_ASSIGNEE_USERS(data: any) {
        axios.get(Endpoints.Admin.TicketsAttributes.INQUIRY_ROLE_ASSIGNEE_USERS(data.projectId, data.roleId))
            .then((response: any) => {
                store.commit(Mutations.SET_INQUIRY_ROLE_ASSIGNEE_USERS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public UPDATE_INQUIRY_TYPE_SORT(data: any) {
        const requestData = {
            itemId: data.itemId,
            relatedId: data.relatedId,
            direction: data.direction,
        };

        axios.post(Endpoints.Admin.TicketsAttributes.UPDATE_INQUIRY_TYPE_SORT, requestData)
            .then(() => {})
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public UPDATE_INQUIRY_CATEGORY_SORT(data: any) {
        const requestData = {
            itemId: data.itemId,
            relatedId: data.relatedId,
            direction: data.direction,
            typeId: data.typeId,
        };

        const projectId = store.getters['TicketAttributes/getCurrentProject'];

        axios.post(Endpoints.Admin.TicketsAttributes.UPDATE_INQUIRY_CATEGORY_SORT(projectId), requestData)
            .then(() => {})
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public UPDATE_INQUIRY_SORT(data: any) {
        const requestData = {
            itemId: data.itemId,
            relatedId: data.relatedId,
            direction: data.direction,
            typeId: data.typeId,
            categoryId: data.categoryId,
        };

        const projectId = store.getters['TicketAttributes/getCurrentProject'];

        axios.post(Endpoints.Admin.TicketsAttributes.UPDATE_INQUIRY_SORT(projectId), requestData)
            .then(() => {})
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public ADD_NEW_INQUIRY_CATEGORY(data: any) {
        const requestData = {
            titles: data.titles,
            typeId: data.typeId,
            roleAssigne: data.roleAssigne,
            roleUser: data.roleUser,
        };

        axios.post(Endpoints.Admin.TicketsAttributes.NEW_INQUIRY_CATEGORY(data.projectId, data.typeId), requestData)
            .then(() => {
                store.dispatch(Actions.FETCH_TICKET_ALL_CATEGORIES, { projectId: data.projectId, typeId: data.typeId, trash: false });

                NotifyHelpers.notify('category_has_been_created', 'positive');

                store.commit(Mutations.SET_CURRENT_TICKET_CATEGORY, 0);
                store.commit(Mutations.SET_ADD_CATEGORY_VISIBILITY, false);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public ADD_NEW_INQUIRY(data: any) {
        const requestData = {
            titles: data.newInquiryTitles,
            messages: data.newInquiryMessages,
            newInquiryAllow: data.newInquiryAllow,
            newInquiryPriority: data.newInquiryPriority,
            categoryId: data.categoryId,
            currentProject: data.currentProject,
            typeId: data.typeId,
        };

        axios.post(Endpoints.Admin.TicketsAttributes.NEW_INQUIRY(data.currentProject, data.categoryId), requestData)
            .then(() => {
                store.dispatch(Actions.FETCH_TICKET_INQUIRIES, { typeId: data.typeId, categoryId: data.categoryId, projectId: data.currentProject});
                store.commit(Mutations.SET_ADD_INQUIRY_VISIBILITY, false);

                NotifyHelpers.notify('inquiry_has_been_created', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public EDIT_INQUIRY_CATEGORY(data: any) {
        const requestData = {
            editCategoryTitles: data.editCategoryTitles,
            editCategoryId: data.editCategoryId,
            editRoleAssigne: data.editRoleAssigne,
            editRoleUser: data.editRoleUser,
        };

        axios.put(Endpoints.Admin.TicketsAttributes.SINGLE_INQUIRY_CATEGORY(data.projectId, data.typeId, data.editCategoryId), requestData)
            .then(() => {
                store.commit(Mutations.SET_CURRENT_EDIT_CATEGORY, []);
                store.dispatch(Actions.FETCH_TICKET_ALL_CATEGORIES, { projectId: data.projectId, typeId: data.typeId, trash: false });
                store.commit(Mutations.SET_EDIT_CATEGORY_VISIBILITY, false);

                NotifyHelpers.notify('category_has_been_updated', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public EDIT_INQUIRY(data: any) {
        const requestData = {
            id: data.id,
            titles: data.titles,
            answers: data.answers,
            allow: data.allow,
            priority: data.priority,
            projectId: data.projectId,
        };

        axios.put(Endpoints.Admin.TicketsAttributes.SINGLE_INQUIRY(data.projectId, data.id), requestData)
            .then(() => {
                store.commit(Mutations.SET_CURRENT_EDIT_INQUIRY, []);
                store.dispatch(Actions.FETCH_TICKET_INQUIRIES, { typeId: data.typeId, categoryId: data.categoryId, projectId: data.projectId});
                store.commit(Mutations.SET_EDIT_INQUIRY_VISIBILITY, false);

                NotifyHelpers.notify('inquiry_has_been_updated', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_ADD_CATEGORY_VISIBILITY(visibility: boolean) {
        this.addCategoryVisible = visibility;
    }

    @Mutation
    public SET_TICKET_ALL_CATEGORIES(data: any) {
        this.ticketAllCategories = data;
    }

    @Mutation
    public SET_TICKET_ALL_TYPES(data: any) {
        this.ticketAllTypes = data;
    }

    @Mutation
    public SET_EDIT_CATEGORY_VISIBILITY(visibility: boolean) {
        this.editCategoryVisible = visibility;
    }

    @Mutation
    public SET_EDIT_INQUIRY_VISIBILITY(visibility: boolean) {
        this.editInquiryVisible = visibility;
    }

    @Mutation
    public SET_ADD_INQUIRY_VISIBILITY(visibility: boolean) {
        this.addInquiryVisible = visibility;
    }

    @Mutation
    public SET_CURRENT_TICKET_TYPE(typeId: number) {
        this.currentTicketType = typeId;
    }

    @Mutation
    public SET_CURRENT_TICKET_CATEGORY(categoryId: number) {
        this.currentTicketCategory = categoryId;
    }

    @Mutation
    public SET_TICKET_ALL_INQUIRIES(data: any) {
        this.ticketAllInquiries = data;
    }

    @Mutation
    public SET_CURRENT_EDIT_CATEGORY(data: any) {
        this.currentEditCategory = data;
    }

    @Mutation
    public SET_CURRENT_EDIT_INQUIRY(data: any) {
        this.currentEditInquiry = data;
    }

    @Mutation
    public SET_INQUIRY_ROLE_ASSIGNEE(data: any) {
        this.inquiryRoles = data;
    }

    @Mutation
    public SET_INQUIRY_ROLE_ASSIGNEE_USERS(data: any) {
        this.inquiryRoleUsers = data;
    }

    @Mutation
    public SET_CURRENT_PROJECTS(projectId: number) {
        this.currentProject = projectId;
    }
}

